import { fork, all, put, call, select, takeLatest } from "redux-saga/effects";

import {
  KPIS_SET_LIST,
  MODELS_SET_LIST,
  MERCH_SET_LIST,
  ACTIONS_SET_LIST,
  REFERENTIELS_SET_PAGINATION,
  IOCS_SET_LIST,
  NETWORKS_SET_LIST,
  CLIENTS_SET_LIST,
  TYPOLOGIES_SET_LIST,
  PROPERTIES_SET_LIST,
  REFERENTIELS_SET_SORT,
  REFERENTIELS_SET_MATCH,
  COMMERCIAL_PERIODS_SET_LIST,
  KPIS_SET_MATCH_FILTERS
} from "../types";

import {
  kpisApiUpsellProvider,
  modelsApiUpsellProvider,
  actionsApiUsellProvider,
  iocsApiUsellProvider,
  networksApiUsellProvider,
  clientsApiProvider,
  typologiesApiUsellProvider,
  propertiesApiUsellProvider,
  merchApiUpsellProvider,
  commercialApiUsellProvider
} from "../../lib/api/providers";

import { MODEL_DELETE, MODEL_SET_LIST_LOADING } from "../actions/modelActions";

const getState = state => state;

const getLoadingAction = sectionName => {
  let loadingAction;
  switch (sectionName) {
    case "kpis":
      break;
    case "models":
      loadingAction = MODEL_SET_LIST_LOADING;
      break;
    case "merch":
      loadingAction = MODEL_SET_LIST_LOADING;
      break;
    case "actions":
      break;
    case "iocs":
      break;
    case "networks":
      break;
    case "clients":
      break;
    case "typologies":
      break;
    case "properties":
      break;
    default:
      break;
  }

  return loadingAction;
};

const getSectionListApi = (state, action) => {
  let apiUpsell;

  const sectionName = action.sectionName;
  const stateSection = state[sectionName] || {};

  switch (sectionName) {
    case "kpis":
      apiUpsell = kpisApiUpsellProvider;
      break;
    case "models":
      apiUpsell = modelsApiUpsellProvider;
      break;
    case "merch":
      apiUpsell = merchApiUpsellProvider;
      break;
    case "actions":
      apiUpsell = actionsApiUsellProvider;
      break;
    case "iocs":
      apiUpsell = iocsApiUsellProvider;
      break;
    case "networks":
      apiUpsell = networksApiUsellProvider;
      break;
    case "clients":
      apiUpsell = clientsApiProvider;
      break;
    case "typologies":
      apiUpsell = typologiesApiUsellProvider;
      break;
    case "properties":
      apiUpsell = propertiesApiUsellProvider;
      break;
    case "commercial":
      apiUpsell = commercialApiUsellProvider;
      break;
    default:
      break;
  }
  const matchValue =
    stateSection.match ||
    (sectionName !== "networks" &&
    sectionName !== "clients" &&
    sectionName !== "typologies" &&
    sectionName !== "properties"
      ? { client_id: state.currentClient.id }
      : {});

  //sort query
  let sort = stateSection.sort || { id: 1, _id: -1 };

  //model
  if (sectionName === "models" || sectionName === "merch" || sectionName === "commercial") {
    matchValue.active = [true, false];
  }

  return apiUpsell
    .post(
      "/",
      {
        match: matchValue,
        sort,
        page: action.page > 0 ? action.page : 1,
        pageSize: stateSection.pageSize
      },
      {
        headers: {
          Authorization: state.auth.token
        }
      }
    )
    .then((response = {}) => response.data);
};

function* getSectionList(action) {
  let loadingAction = getLoadingAction(action.sectionName);
  try {
    const state = yield select(getState);

    let typeValue;

    switch (action.sectionName) {
      case "kpis":
        typeValue = KPIS_SET_LIST;
        break;
      case "models":
        typeValue = MODELS_SET_LIST;
        break;
      case "merch":
        typeValue = MERCH_SET_LIST;
        break;
      case "actions":
        typeValue = ACTIONS_SET_LIST;
        break;
      case "iocs":
        typeValue = IOCS_SET_LIST;
        break;
      case "networks":
        typeValue = NETWORKS_SET_LIST;
        break;
      case "clients":
        typeValue = CLIENTS_SET_LIST;
        break;
      case "typologies":
        typeValue = TYPOLOGIES_SET_LIST;
        break;
      case "properties":
        typeValue = PROPERTIES_SET_LIST;
        break;
      case "commercial":
        typeValue = COMMERCIAL_PERIODS_SET_LIST;
        break;
      default:
        break;
    }
    yield put({ type: loadingAction, loading: true });
    const data = yield call(getSectionListApi, state, action);
    yield put({ type: typeValue, payload: data });
    yield put({ type: loadingAction, loading: false });
  } catch (e) {
    console.log(e.message);
    yield put({ type: loadingAction, loading: false });
  }
}

function* setSort(action) {
  //alert(`-> ${action.sectionName} ${action.column} ${action.order}`);
}

function* setMatchReferentiel({ sectionName, match }) {
  let setMatchReducer;
  switch (sectionName) {
    case "kpis":
      setMatchReducer = KPIS_SET_MATCH_FILTERS;
      break;
    default:
      break;
  }
  yield put({ type: setMatchReducer, payload: match });
  yield call(getSectionList, { sectionName });
}

//Fetch filters data
function* watchSetPagination() {
  yield takeLatest(REFERENTIELS_SET_PAGINATION, getSectionList);
}

function* watchSetSort() {
  yield takeLatest(REFERENTIELS_SET_SORT, setSort);
}

function* watchSetMatch() {
  yield takeLatest(REFERENTIELS_SET_MATCH, setMatchReferentiel);
}

export default function* root() {
  yield all([fork(watchSetPagination), fork(watchSetSort), fork(watchSetMatch)]);
}

/*export default function* root() {
  yield [takeLatest(REFERENTIELS_SET_PAGINATION, getSectionList), takeLatest(REFERENTIELS_SET_SORT, setSort)];
}*/



// WEBPACK FOOTER //
// src/redux/sagas/referentielsSagas.js